import React, { FunctionComponent } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import { Auth } from '@justgiving/auth';
import { ExperimentContext } from '@justgiving/experiments';
import { ApolloClient, ApolloProvider } from '@apollo/client';

import App from '../../App';
import config, { AppFlags } from '../../client/config';
import { AuthContext } from '../../context/AuthContext';
import { FlagsProvider } from '../../context/FlagContext';
import {
  PageMetaContext,
  PageMetaContextProvider,
  DonationAmountProvider,
} from '../../context';

type AppWithProvidersProps = {
  helmetProviderContext?: {};
  pageMetaContextProviderValue: PageMetaContext | null;
  apolloProviderClient: ApolloClient<any>;
  i18n: any;
  auth: Auth;
  flagOverrides?: Partial<AppFlags>;
};

const AppWithProviders: FunctionComponent<AppWithProvidersProps> = ({
  helmetProviderContext,
  pageMetaContextProviderValue,
  apolloProviderClient,
  i18n,
  auth,
  flagOverrides,
}) => {
  return (
    <AuthContext.Provider value={auth}>
      <FlagsProvider value={{ ...config.flags, ...(flagOverrides ?? {}) }}>
        <HelmetProvider context={helmetProviderContext}>
          <PageMetaContextProvider value={pageMetaContextProviderValue}>
            <ApolloProvider client={apolloProviderClient}>
              <ExperimentContext.Provider
                value={{
                  abServiceUrl: config.abApiUrl,
                  analyticsCookieName: config.analyticsCookieName,
                }}
              >
                <DonationAmountProvider>
                  <App i18n={i18n} />
                </DonationAmountProvider>
              </ExperimentContext.Provider>
            </ApolloProvider>
          </PageMetaContextProvider>
        </HelmetProvider>
      </FlagsProvider>
    </AuthContext.Provider>
  );
};

export default AppWithProviders;
